// src/components/SectorTabs.jsx
import React from 'react'

export default function SectorTabs({ sectors, activeKey, onChange }) {
  return (
    <div className="flex flex-wrap gap-3 md:gap-4 items-center mx-[5%] md:mx-[10%] mt-8">
      
      <button
        onClick={() => onChange('all')}
        className={`px-5 py-2 md:px-6 md:py-3 rounded-full text-base md:text-lg font-medium shadow-sm ${
          activeKey === 'all'
            ? 'bg-[#027d9b] text-white'
            : 'bg-white text-gray-900 border'
        }`}
      >
        All
      </button>

      {sectors.map(s => (
        <button
          key={s.key}
          onClick={() => onChange(s.key)}
          className={`px-5 py-2 md:px-6 md:py-3 rounded-full text-base md:text-lg font-medium shadow-sm ${
            activeKey === s.key
              ? 'bg-[#027d9b] text-white'
              : 'bg-white text-gray-900 border'
          }`}
        >
          {s.sector}
        </button>
      ))}
    </div>
  )
}










//=======>> Old one




// // src/components/SectorTabs.jsx
// import React from 'react'

// export default function SectorTabs({ sectors, activeKey, onChange }) {
//   return (
//     <div className="flex flex-wrap gap-2 md:gap-4 items-center mx-[5%] md:mx-[10%] mt-8">
//       <button
//         onClick={() => onChange('all')}
//         className={`px-3 py-1 md:px-4 md:py-2 rounded-full text-sm md:text-base font-medium ${
//           activeKey === 'all' ? 'bg-[#027d9b] text-white' : 'bg-white text-gray-700 border'
//         }`}
//       >
//         All
//       </button>

//       {sectors.map(s => (
//         <button
//           key={s.key}
//           onClick={() => onChange(s.key)}
//           className={`px-3 py-1 md:px-4 md:py-2 rounded-full text-sm md:text-base font-medium ${
//             activeKey === s.key ? 'bg-[#027d9b] text-white' : 'bg-white text-gray-700 border'
//           }`}
//         >
//           {s.sector}
//         </button>
//       ))}
//     </div>
//   )
// }
